import { createAction } from '@reduxjs/toolkit';

export const rootActions = {
  resetStore: createAction('root/reset'),
};
